class MotoCarousel extends HTMLElement {
  connectedCallback() {
    this.track = this.querySelector('[data-moto-track]');
    if (!this.track) return;
    this.querySelectorAll('[data-moto-direction]').forEach((button) => {
      button.addEventListener('click', () => {
        const direction = button.dataset.motoDirection === 'next' ? 1 : -1;
        const item = this.track.firstElementChild;
        const gap = parseFloat(getComputedStyle(this.track).gap) || 0;
        this.track.scrollBy({ left: direction * ((item?.getBoundingClientRect().width || this.track.clientWidth) + gap), behavior: 'smooth' });
      });
    });
  }
}
if (!customElements.get('moto-carousel')) customElements.define('moto-carousel', MotoCarousel);

const spotlight = document.querySelector('[data-moto-spotlight]');
const spotlightInput = spotlight?.querySelector('[data-moto-spotlight-input]');
const openSpotlight = () => {
  if (!spotlight?.open) spotlight?.showModal();
  requestAnimationFrame(() => spotlightInput?.focus());
};
const closeSpotlight = () => spotlight?.close();
document.querySelectorAll('[data-moto-spotlight-open]').forEach((button) => button.addEventListener('click', openSpotlight));
spotlight?.querySelector('[data-moto-spotlight-close]')?.addEventListener('click', closeSpotlight);
spotlight?.addEventListener('click', (event) => {
  if (event.target === spotlight) closeSpotlight();
});
document.addEventListener('keydown', (event) => {
  if ((event.metaKey || event.ctrlKey) && event.key.toLowerCase() === 'k') {
    event.preventDefault();
    openSpotlight();
  }
});
